import Handlebars from "hbs";

// ==========================================================================
// Data
// ==========================================================================
//import Locations from "../../copy/uk/storeLocations.json";

// ==========================================================================
// Templates
// ==========================================================================
import StoresTemplate from "../../templates/components/store-locator/stores.html";
import InfoWindowTemplate from "../../templates/components/store-locator/info-window.html";
import ConfirmPopup from "./confirmPopup";

// import InfoMatteoTemplate from '../../templates/components/store-locator/matteo-window.html'

// ==========================================================================
// Popup
// ==========================================================================
import StoreLocatorPopups from "./storeLocatorPopups-v1";
import { map } from "lodash";

import SaLogin from "./saLogin";




export default class StoreLocatorv1 {
  /* Constructor */
  constructor() {
    const _this = this;

    this.$root = $("#store-locator");
    this.$map = this.$root.find(".store-locator__map");
    this.$searchBox = this.$root.find(".store-locator__search");

    this.templates = {};
    this.templates.stores = StoresTemplate;
    this.templates.infoWindow = InfoWindowTemplate;

    this.today = new Date();
    this.year = this.today.getFullYear();
    this.month = ("0" + (this.today.getMonth() + 1)).slice(-2);
    this.day = ("0" + this.today.getDate()).slice(-2);
    this.todayString = `${this.year}-${this.month}-${this.day}`;
    this.ajaxInfoLoaded = 0;

    this.saLogin = new SaLogin()

    setTimeout(() => {
            if (window.state.isUserLoggedIn) { // or use localStorage if available
                //console.log("User already logged in, restoring state."); // Debug log
                this.restoreLocationData();
                this.restoreUserState();
            } else {
                console.log("User is not logged in or login check not yet completed.");
            }
        }, 2500); // Adjust the timeout as needed to allow `isUserLoggedIn` to complete

    //console.log('StoreLocator Loaded');
    this.getLocations();

    this.days = {
      long: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    };

  }


  getLocations() {

    var _this = this;

    var url =
      "https://samsung-repair-prices.s3.eu-west-2.amazonaws.com/stores/";

    var fileName =
      window.location.host == "www.samsung.com"
        ? "storeLocations-v1.json"
        : "storeLocations-new-v1.json";
    //var fileName = "storeLocations-new-v1.json";
    var cacheBustor = Math.floor(Math.random() * 1000000000);
    fileName = fileName + "?v=" + cacheBustor;

    url = url + fileName;

    //console.log(url);

    let inWarranty = window.state.tsoutcome.warrantyException;
    let productType = window.state.product;
    // console.log(productType);
    // console.log(inWarranty);

    var warrantyStatus = "";

    if (inWarranty == "VOID1" || inWarranty == "") {
      warrantyStatus = "OW";
    } else {
      warrantyStatus = "IW";
    }

    //console.log("warranty status is set to=" + warrantyStatus);
    //var locations = "";

    _this.locations = [];

    $.get(url, function (data) {

      const storeExclusions = {
        "Galaxy A04s": ["EE"],
        "Galaxy A23 5G": ["EE"],
        "Galaxy M13": ["EE"],
        "Galaxy M33 5G": ["EE"],
        "Galaxy M53 5G": ["EE"],
        "Galaxy M23 5G": ["EE"],
        "Galaxy M22": ["EE"],
        "Galaxy M52 5G": ["EE"],
        "Galaxy M32": ["EE"],
        "Galaxy A72": ["EE"],
        "Galaxy M12": ["EE"],
        "Galaxy M51": ["EE"],
        "Galaxy M31S": ["EE"],
        "Galaxy A31": ["EE"],
        "Galaxy M11": ["EE"],
        "Galaxy NOTE 10 Lite": ["EE"],
        "Galaxy A30s": ["EE"],
        "Galaxy NOTE 10": ["EE"],
        "Galaxy NOTE 10+": ["EE"],
        "Galaxy NOTE 10+ 5G": ["EE"],
        "Galaxy A2 CORE": ["EE"],
        "Galaxy A80": ["EE"],
        "Galaxy A30": ["EE"],
        "Galaxy S9": ["EE"],
        "Galaxy S9+": ["EE"],
        "Galaxy A9": ["EE"],
        "Galaxy J4+": ["EE"],
        "Galaxy NOTE 9": ["EE"],
        "Galaxy A6 2018": ["EE"],
        "Galaxy NOTE 8": ["EE"],
        "Galaxy J3 2017": ["EE"],
        "Galaxy J5 2017": ["EE"],
        "Galaxy S8": ["EE"],
        "Galaxy S8+": ["EE"],
        "Galaxy A3 2017": ["EE"],
        "Galaxy A3 2016": ["EE"],
        "Galaxy S7": ["EE"],
        "Galaxy S7 EDGE": ["EE"],
        "Galaxy A5 2017": ["EE"],
        "Galaxy A8": ["EE"],
        "Galaxy A7": ["EE"],
        "Galaxy A3": ["EE"],
        "Galaxy A5": ["EE"],
        "Galaxy J6": ["EE"],
        "Galaxy J6+": ["EE"],
      };
      //prettyfy error remove string marks from flip and fold, need to check when iSmash logic will change
      const storeExclusionsCategory = {
        Flip: ["iSmash"],
        Fold: ["iSmash"],
      };

      const iSmashApprovedModels = [
        "Galaxy A20s",
        "Galaxy A21s",
        "Galaxy A32 4G",
        "Galaxy A32 5G",
        "Galaxy A40",
        "Galaxy A41",
        "Galaxy A42 5G",
        "Galaxy A50",
        "Galaxy A51 5G",
        "Galaxy A52 5G",
        "Galaxy A52s 5G",
        "Galaxy A53 5G",
        "Galaxy A54 5G",
        "Galaxy A70",
        "Galaxy A71",
        "Galaxy NOTE 10",
        "Galaxy NOTE 10+",
        "Galaxy NOTE 10+ 5G",
        "Galaxy NOTE 20",
        "Galaxy NOTE 20 5G",
        "Galaxy NOTE 20 Ultra 5G",
        "Galaxy S10",
        "Galaxy S10 5G",
        "Galaxy S10 Lite",
        "Galaxy S10+",
        "Galaxy S10+ Ceramic",
        "Galaxy S10e",
        "Galaxy S20",
        "Galaxy S20 5G",
        "Galaxy S20 FE",
        "Galaxy S20 FE 5G",
        "Galaxy S20 Ultra 5G",
        "Galaxy S20+",
        "Galaxy S20+ 5G",
        "Galaxy S21 5G",
        "Galaxy S21 FE 5G",
        "Galaxy S21 Ultra 5G",
        "Galaxy S21+ 5G",
        "Galaxy S22 5G",
        "Galaxy S22 Ultra 5G",
        "Galaxy S22+ 5G",
        "Galaxy S23 5G",
        "Galaxy S23 Ultra 5G",
        "Galaxy S23+ 5G",
        "Galaxy S24 Ultra",
        "Galaxy S24",
        "Galaxy S24+",
        "Galaxy S24 FE",
        "Galaxy S8",
        "Galaxy S8+",
        "Galaxy S9",
        "Galaxy S9+",
        "Galaxy A05s",
        "Galaxy A15 5G",
        "Galaxy A15 LTE",
        "Galaxy A25 5G",
        "Galaxy A16 5G",
        "Galaxy A16 LTE"
      ];

      function formatStringForComparison(str) {
        return str
          .replace(/\s+/g, "")
          .replace("+", "Plus")
          .replace(/samsung\//gi, "")
          .toLowerCase();
      }

      let rawProductString = window.state.tsoutcome.troubleshootedProduct;
      const productString = formatStringForComparison(rawProductString);

      let isMatched = false;
      let matchedModel = null; // To hold the matched model or category
      let excludedStores = [];

      for (const category in storeExclusionsCategory) {
        if (productString.includes(category.toLowerCase())) {
          // Just a simple includes check now
          isMatched = true;
          matchedModel = category;
          excludedStores = storeExclusionsCategory[category] || [];
          break;
        }
      }

      if (!isMatched) {
        for (const key in storeExclusions) {
          const formattedKey = formatStringForComparison(key);
          if (productString === formattedKey) {
            isMatched = true;
            matchedModel = key;
            excludedStores = storeExclusions[key] || [];
            break;
          }
        }
      }


      // Process the stores
      const formattediSmashApprovedModels = iSmashApprovedModels.map((model) =>
        formatStringForComparison(model)
      );
      for (let loc = 0; loc < data.stores.length; loc++) {
        const store = data.stores[loc];
        // console.log(store)
        if (store.store_type === "iSmash") {
          if (!formattediSmashApprovedModels.includes(productString)) {
            // console.log(`iSmash store found, but model ${rawProductString} (${productString}) is not approved.`);
            continue;
          }
        } else if (isMatched && excludedStores.includes(store.store_type)) {
          continue;
        }

        if (
          store.open_now &&
          store.repair_offering.includes(warrantyStatus) &&
          store.repair_offering.includes(productType)
        ) {

          _this.locations.push(store);
        }
      }
    })
      .done(function () {
        console.log(_this.data);
        _this.appData = _this.data(_this.locations);
        console.log(_this.appData);
        _this.initialiseMap();
        _this.searchBox();
      })
      .fail(function () {
        console.log("error getting Store location json data");
      })
      .always(function () {
        //alert( "finished" );
      });
  }

  data(locations) {
    return {
      locations: locations,
      pristine: true,
      distanceThreshold: 1000000,
      /* Distance in meters */
      initCenterPoint: {
        lat: 54.221107,
        lng: -4.63097,
      },
      markers: {},
      infoWindows: [],
      stores: [],
    };
  }

  initialiseMap() {
    const _this = this;

    _this.map = new google.maps.Map(_this.$map[0], {
      center: {
        lat: _this.appData.initCenterPoint.lat,
        lng: _this.appData.initCenterPoint.lng,
      },
      zoom: 6,
    });

    /* Bias the locations towards current location of map */
    _this.map.addListener("idle", (event) => {
      //_this.search.setBounds( _this.map.getBounds() ) //TODO
    });
  }

  initialiseMapWithMarkers() {
    this.createMarkers();
  }

  defaultPlace() {
    this.initialiseMapWithMarkers();
    this.filteredLocations = this.appData.locations;
    this.populateLocatorList(null);
    this.initMarkerEvents();
  }

  searchBox() {
    var _this = this;

    this.search = new google.maps.places.Autocomplete(this.$searchBox[0]);

    /* Only UK results */
    this.search.setComponentRestrictions({
      country: ["gb", "ie"],
    });

    this.search.addListener("place_changed", function () {
      //$(".loader-container").show();

      //console.log("place changed");

      var icon = document.getElementsByClassName(
        "material-icons md-24 sl-input-icon"
      )[0];
      icon.style.display = "none";
    });

    /* Event for location select */
    this.search.addListener("place_changed", (event) => {
      var place = this.search.getPlace(); // TODO
      $(".sl-wrapper-inner").show();
      //console.log("Place");
      //console.log(place);
      //console.log(place.geometry);

      var searchBoxVal = this.$searchBox.val();
      //console.log(searchBoxVal);

      /* User hasn't selected a place */
      if (!place.geometry) return;

      this.initialiseMapWithMarkers();

      this.usersLocation = place;

      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.setCenter(place.geometry.location);
      }

      /* Set zoom level */
      this.map.setZoom(12);
      /* Filter/reduce locations to 30 miles */
      //this.filterLocations(place);
      var filteredLocations = this.filterLocations(place);
      /* Calc distances & order */
      //this.calculateDistances(place);
      var distanceCalculated = this.calculateDistances(place);

      //this.populateLocatorList(place);
      // Given some delay and assign return values to a variable for previous two calls to fix the issues related to
      //nearest store of selected location should be center of the map
      setTimeout(() => this.populateLocatorList(place), 200);

      //   this.initMarkerEvents();
    });

    //Find User
    //navigator.geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          _this.map.setCenter(pos);
          _this.map.setZoom(12);

          var geocoder = new google.maps.Geocoder();
          var latlng = new google.maps.LatLng(pos.lat, pos.lng);

          geocoder.geocode(
            {
              latLng: latlng,
            },
            function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                _this.initialiseMapWithMarkers();

                var place = results[0];

                //console.log(place);

                _this.filterLocations(place);

                /* Calc distances & order */
                _this.calculateDistances(place);

                _this.populateLocatorList(place);

                _this.initMarkerEvents();
              } else {
                console.log("Geolocation not found.");
                _this.defaultPlace();
              }
            }
          );
        },
        function (err) {
          console.log("Permission Denied", err);

          if (!searchBoxVal) {
            _this.defaultPlace();
          }

        },
        {
          enableHighAccuracy: true,
        }
      );
    } else {
      _this.defaultPlace();
    }
  }

  calculateDistances(start, end) {
    const _this = this;
    var startLatLong = start.geometry.location;

    var locations = [];

    var service2 = new google.maps.DistanceMatrixService();
    var formattedAddresses = this.filteredLocations.map((location) => {
      return location.formatted_address;
    });

    service2.getDistanceMatrix(
      {
        origins: [startLatLong],
        destinations: formattedAddresses,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        avoidHighways: false,
        avoidTolls: false,
      },
      (res, status) => {
        if (status === "OK") {
          var stores = _this.filteredLocations.map((location, index) => {
            var store = location;
            store.distanceMatrix = res.rows[0].elements[index];
            return store;
          });

          _this.appData.stores = stores.sort((a, b) => {
            if (a.distanceMatrix.duration && b.distanceMatrix.duration) {
              if (
                parseInt(a.distanceMatrix.duration.value) <
                parseInt(b.distanceMatrix.duration.value)
              )
                return -1;
              if (
                parseInt(a.distanceMatrix.duration.value) >
                parseInt(b.distanceMatrix.duration.value)
              )
                return 1;
              return 0;
            } else {
              return 0;
            }
          });
        } else {
          console.info("Stores Error ", status);
        }
      }
    );
  }

  filterLocations(start) {
    var near = this.appData.locations.filter((location) => {
      var distance = this.haversine(
        start.geometry.location,
        new google.maps.LatLng(location.geometry.location)
      );

      if (distance < this.appData.distanceThreshold) {
        location.haversine = distance;
        return location;
      }
    });

    // PRIOR SORTING? add this to above function
    // console.log(this.appData.locations.filter(location => {
    //   //do the extra filtering here, for now im just filtering by KX but lets change this to whatever device was clicked and in or out of warranty
    //   if (location.store_type == 'KX'){
    //     return location;
    //   }
    // }));

    var sorted = near.sort((a, b) => {
      if (parseInt(a.haversine) < parseInt(b.haversine)) return -1;
      if (parseInt(a.haversine) > parseInt(b.haversine)) return 1;
      return 0;
    });

    this.filteredLocations = sorted.slice(0, 25); /* Get cloests 25 results */
  }

  haversine(origin, destination) {
    return google.maps.geometry.spherical.computeDistanceBetween(
      origin,
      destination
    );
  }

  createMarkers(zoomLevel) {
    var _this = this;
    var mapBounds = this.map.getBounds();

    //console.log(this.filteredLocations);

    this.appData.locations
      .filter((location) => {
        //do the extra filtering here, for now im just filtering by KX but lets change this to whatever device was clicked and in or out of warranty
        // if (location.store_type == 'SES'){
        //   return location;
        // }

        return location;
      })
      .forEach((location) => {
        //change colour of each location, add new field to CMS with short name,
        // Samsung, EE, iSmash -- then use this color variable below in the icon set up
        if (
          location.store_type == "KX" ||
          location.store_type == "SES" ||
          location.store_type == "SSC"
        ) {
          if (zoomLevel <= 10) {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#000000",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(6.75, 15),
              scaledSize: new google.maps.Size(13.5, 15),
            };
          } else {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#000000",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(13.5, 41),
              scaledSize: new google.maps.Size(27, 41),
            };
          }
        } else if (location.store_type == "EE") {
          if (zoomLevel <= 10) {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#009ba5",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(6.75, 15),
              scaledSize: new google.maps.Size(13.5, 15),
            };
          } else {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#009ba5",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(13.5, 41),
              scaledSize: new google.maps.Size(27, 41),
            };
          }
        } else {
          if (zoomLevel <= 10) {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#FF148B",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(6.75, 15),
              scaledSize: new google.maps.Size(13.5, 15),
            };
          } else {
            var icon = {
              path: "M25.962,14.520 C25.982,14.212 25.996,13.902 25.996,13.590 C25.996,13.581 25.995,13.573 25.995,13.565 C25.995,13.559 25.996,13.552 25.996,13.545 L25.995,13.546 C25.972,6.053 20.160,-0.014 12.991,-0.014 C5.823,-0.014 0.010,6.053 -0.012,13.546 L-0.013,13.545 C-0.013,13.545 -0.093,14.215 0.131,15.611 C0.216,16.214 0.343,16.803 0.502,17.378 C1.521,21.402 4.467,28.726 12.874,39.991 C12.874,39.991 24.604,26.231 25.878,15.400 C25.907,15.165 25.932,14.928 25.950,14.689 C25.954,14.633 25.959,14.576 25.962,14.520 ZM12.991,7.430 C16.243,7.430 18.879,10.188 18.879,13.590 C18.879,16.991 16.243,19.749 12.991,19.749 C9.739,19.749 7.103,16.991 7.103,13.590 C7.103,10.188 9.739,7.430 12.991,7.430 Z",
              fillColor: "#FF148B",
              fillOpacity: 1,
              fillRule: "evenodd",
              stroke: "none",
              strokeWeight: 0,
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(13.5, 41),
              scaledSize: new google.maps.Size(27, 41),
            };
          }
        }

        /* Resize icon for zoom level */

        var marker = new google.maps.Marker({
          map: this.map,
          icon: icon,
          title: location.name,
          position: location.geometry.location,
          id: location.place_id,
        });

        /* Set template left list
            var getsource = this.template['storeList']
            var template = Handlebars.compile( getsource );
            var compiled = template({
                location: location,
                origin: this.usersLocation,
            }); */

        /* Set template */
        var source = this.templates["infoWindow"];
        var template = Handlebars.compile(source);
        var compiled = template({
          location: location,
          origin: this.usersLocation,
        });

        var infoWindow = new google.maps.InfoWindow({
          content: compiled,
        });

        this.appData.infoWindows.push(infoWindow);

        marker.addListener("click", () => {
          this.closeInfoWindows();
          infoWindow.open(this.map, marker);

          setTimeout(function () {
            _this.initMarkerEvents();
          }, 200);
        });

        window.markers = this.appData.markers[location.place_id] = marker;
      });
  }

  selectStore(id) {
    var store = this.state.stores.filter((store) => {
      if (store.place_id === id) {
        return store;
      }
    });

    this.map.setZoom(12);

    return store;
  }

  clearMarkers() {
    var o = 0;
    for (var i in this.appData.markers) {
      o++;
      this.appData.markers[i] = null;
    }
  }

  closeInfoWindows() {
    this.appData.infoWindows.map((infoWindow) => {
      infoWindow.close();
    });
  }

  events() {
    this.$root.find(".store-locator__store").on("click", (event) => {
      var $element = $(event.target);

      if (!$element.hasClass("store-locator__store")) {
        $element = $(event.target).parents(".store-locator__store");
      }

      if (!$element.hasClass("store-locator__store"))
        var $element = $(event.target).parent(".store-locator__store");

      const storeId = $element.attr("data-store");
      const marker = this.appData.markers[storeId];

      /* Center map to marker */
      this.map.setCenter(marker.getPosition());

      /* Trigger click on infowindow */
      google.maps.event.trigger(marker, "click");

      /* Select store by ID */
      this.selectStore(storeId);

      /* Remove current select classes */
      this.$root
        .find(".store-locator__store--selected")
        .removeClass("store-locator__store--selected");

      /* Add selected class to current store */
      $element.addClass("store-locator__store--selected");
    });
  }

    initMarkerEvents() {

    const saLogin = new SaLogin()

    $(".reservation-marker")
        .off("click")
        .on("click", (e) => {
            e.preventDefault();

            const $element = e.currentTarget;
            // console.log("Clicked reservation marker:", $element);
            const href = $element.getAttribute("href");

            // Check if the store is 'iSmash' or 'EE' and skip login prompt if true
            if (href.indexOf("ismash") > -1 || href.indexOf("appointment.ee") > -1 || href.indexOf("greetme-appointment-test") > -1) {
                // Handle iSmash or EE store booking directly without login check
                this.handleStoreBooking($element);
                return;
            }

            // Save location data to localStorage before login
            const locationData = {
                placeId: $element.getAttribute("place_id"),
                storeName: $element.getAttribute("store_name"),
                storeAddress: $element.getAttribute("store_address"),
                phone: $element.getAttribute("phone"),
                dropOffService: $element.getAttribute("drop_off_service"),
                qudini: $element.getAttribute("qudini"),
                storeType: $element.getAttribute("store_type")
                // Add other necessary attributes as needed
            };
            // console.log("Saving location data to localStorage:", locationData);
            localStorage.setItem("selectedLocation", JSON.stringify(locationData));

            // For other stores, check login status before proceeding
            saLogin.isUserLoggedIn().done(() => {
                if (!window.state.isUserLoggedIn) {
                    // Save the current state for redirection after login
                    this.saveUserState($element);

                    // Trigger login banner
                    // $(".nv00-gnb .nv00-gnb__utility-wrap .loginBtn").trigger("click");
                    if ($('#sa-login').length) {
                      $('#sa-login').show();
                      $(".sl-selector-start").hide(1);
                      $(".sl-map").hide();
                    } else {
                      console.error("Element #sa-login not found in DOM.");
                    }
                    return; // Stop further actions until login is confirmed
                }

                // Proceed with booking if logged in
                this.handleStoreBooking($element);
            }).fail(() => {
                console.error("Login check failed. Please try again.");
            });
        });
    }

    restoreLocationData() {
    const locationData = JSON.parse(localStorage.getItem("selectedLocation"));

    if (locationData) {
        //console.log("Restoring saved location data:", locationData); // Debug log

        // Repopulate location fields as needed
        $("#place_id").val(locationData.placeId); // Example field; replace with actual selectors
        $("#store_name").text(locationData.storeName);
        $("#store_address").text(locationData.storeAddress);
        $("#phone").text(locationData.phone);
        // Add other fields based on your UI structure

        // Clear the saved location after restoring to avoid duplicate data
        localStorage.removeItem("selectedLocation");
    } else {
        console.error("No location data found in localStorage.");
    }
    }

    // Helper function to handle the store booking based on the store type
    handleStoreBooking($element) {
        const href = $element.getAttribute("href");

        if (href.indexOf("ismash") > -1) {
            // iSmash booking flow
            const popupText = "You will now be directed to our authorised repair partner website.";
            let popupCtaUrl = href;
            const lucidRef = window.state.tsoutcome.lucidRef;
            const troubleshootedProduct = window.state.tsoutcome.troubleshootedProduct.replace("Samsung/", "").replace("Galaxy", "").replace("2017", "").replace("Plus", "+");

            popupCtaUrl += "?model=" + troubleshootedProduct + "&ref=" + lucidRef;

            this.confirmPopup = new ConfirmPopup(popupText, popupCtaUrl);
            this.confirmPopup.showConfirmPopup();
        } else if (href.indexOf("appointment.ee") > -1 || href.indexOf("greetme-appointment-test") > -1) {
            // EE booking flow
            const popupText = "You will now be directed to our authorised repair partner website.";
            let popupCtaUrl = href;
            const storeId = $element.getAttribute("place_id");
            const lucidRef = window.state.tsoutcome.lucidRef;

            popupCtaUrl += "&location_id=" + storeId + "&device=Samsung " + window.state.tsoutcome.tsProductNameForDisplay + "&refnum=" + lucidRef + "&issue=" + window.state.tsoutcome.selectedIssue;

            this.confirmPopup = new ConfirmPopup(popupText, popupCtaUrl);
            this.confirmPopup.showConfirmPopup();
        } else {
            // Samsung store booking flow
            // console.log('is this the flow we in?')
            $(".sl-selector-start").hide(1);
            $(".sl-appointment-start").show(1);

            $(".sl-appointment-start").data("location", $element.getAttribute("place_id"));
            $(".sl-appointment-start").data("phone", $($element).data("phone") || $element.getAttribute("phone"));
            $(".sl-appointment-start").data("qudini", $($element).data("qudini") || $element.getAttribute("qudini"));
            $(".sl-appointment-start").data("store_type", $($element).data("store_type") || $element.getAttribute("store_type"));
            $(".sl-appointment-start").data("store_address", $($element).data("store_address") || $element.getAttribute("store_address"));
            $(".sl-appointment-start").data("store_name", $($element).data("store_name") || $element.getAttribute("store_name"));
            $(".sl-appointment-start").data("drop_off_service", $($element).data("drop_off_service") || $element.getAttribute("drop_off_service"));

            this.closeInfoWindows();
            new StoreLocatorPopups();
        }
    }

    // Function to save user state before redirecting to login
    saveUserState($element) {
        const state = {
            placeId: $element.getAttribute("place_id"),
            href: $element.getAttribute("href"),
            phone: $($element).data("phone") || $element.getAttribute("phone"),
            qudini: $($element).data("qudini") || $element.getAttribute("qudini"),
            store_type: $($element).data("store_type") || $element.getAttribute("store_type"),
            store_address: $($element).data("store_address") || $element.getAttribute("store_address"),
            store_name: $($element).data("store_name") || $element.getAttribute("store_name"),
            drop_off_service: $($element).data("drop_off_service") || $element.getAttribute("drop_off_service"),
        };
        localStorage.setItem("userState", JSON.stringify(state));
    }

    // Function to restore user state after login
    restoreUserState() {

        const state = JSON.parse(localStorage.getItem("userState"));
        if (state) {
            const $dummyElement = $('<a>')
                .addClass("reservation-marker")
                .attr("data-omni-type", "microsite")
                .attr("href", state.href)
                .attr("place_id", state.placeId)
                .attr("phone", state.phone)
                .attr("qudini", state.qudini)
                .attr("store_type", state.store_type)
                .attr("store_address", state.store_address)
                .attr("store_name", state.store_name)
                .attr("drop_off_service", state.drop_off_service);

                // console.log($dummyElement[0], 'this is the dummy element')

                this.handleStoreBooking($dummyElement[0]);
                window.supportComponents.steps.setActiveStep(3);
                $('.lds-ring1').hide()
                $('.s-layer-dimmed').hide()

            // Clear state after restoring
            localStorage.removeItem("userState");
        }
    }


  populateLocatorList(start) {
    var resultList = document.getElementById("resultList");

    while (resultList.firstChild) {
      resultList.removeChild(resultList.firstChild);
    }

    var numberOfStoresToDisplay = this.filteredLocations.length;

    // console.log(this.filteredLocations, "filteredLocations from Store Locator");

    this.ajaxInfoLoaded = 0;

    // Find the KX store
    let kxStoreIndex = this.filteredLocations.findIndex(
      (location) => location.store_type === "KX"
    );
    // console.log(kxStoreIndex, "kxStoreIndex");
    let KXpositionChanged = false;
    if (numberOfStoresToDisplay > 0) {
      // Move the KX store to the first position if found and within 15 miles
      if (kxStoreIndex !== -1) {
        const kxStore = this.filteredLocations[kxStoreIndex];
        const distanceToFirstStore =
          this.haversine(
            kxStore.geometry.location,
            this.filteredLocations[0].geometry.location
          ) / 1609.34; // Convert meters to miles

        // console.log(distanceToFirstStore, "distanceToFirstStore");

        if (distanceToFirstStore > 0 && distanceToFirstStore <= 11.5) {
          this.filteredLocations.splice(kxStoreIndex, 1);
          this.filteredLocations.unshift(kxStore);
          KXpositionChanged = true;
        }
      }
    }

    for (var i = 0; i < numberOfStoresToDisplay; i++) {
      if (this.filteredLocations[i]) {
        //In case less than 3 results are within the search distance
        var currentAddress =
          this.filteredLocations[i]["formatted_address"].split(", ");
        var storeName = this.filteredLocations[i]["name"];
        var distance = "";
        if (start != null) {
          distance =
            parseInt(
              this.haversine(
                start.geometry.location,
                new google.maps.LatLng(
                  this.filteredLocations[i].geometry.location
                )
              )
            ) / 1000;
        }

        var li = document.createElement("li");
        var title = document.createElement("h3");
        title.style.position = "relative";
        title.setAttribute("id", "title-" + i);
        var p1 = document.createElement("p");
        var p2 = document.createElement("p");
        var p3 = document.createElement("p");
        const nextBookingTitle = document.createElement("p");
        nextBookingTitle.classList.add("next-booking-title");
        nextBookingTitle.innerText = "Next booking time:";
        const nextBookingParagraph = document.createElement("p");
        nextBookingParagraph.classList.add("next-booking-text");
        nextBookingParagraph.classList.add(
          `qudini-${this.filteredLocations[i]["qudini"]}`
        );

        var a = document.createElement("a");

        li.classList.add("sl-store-list-single-result");

        const spanEl =
          "<span style='font-size: 16px; position:relative; display: block;margin-bottom: 5px; color:rgb(33, 137, 252)'>Flagship Store</span>";

        // title.innerHTML =
        KXpositionChanged ||
          (!KXpositionChanged && this.filteredLocations[0].store_type === "KX");

        //     ? spanEl + storeName
        //     : i + ". " + storeName
        //   : i +
        //     1 +
        //     ". " +
        //     storeName +

        let message =
          KXpositionChanged && i === 0
            ? spanEl
            : i + (KXpositionChanged ? "" : 1) + ". ";
        if (
          !KXpositionChanged &&
          this.filteredLocations[0].store_type === "KX" &&
          i === 0
        ) {
          message = spanEl + (i + 1) + ". ";
        }
        title.innerHTML =
          message +
          storeName +
          (distance == ""
            ? ""
            : " - " +
              "<span>" +
              //   (Math.round(distance * 100) / 100).toString() +
              //   "km" +
              (distance >= 0.8
                ? (
                    Math.round((distance / 1.60934449789) * 10) / 10
                  ).toString() + "mi"
                : Math.round(distance * 1093.61).toString() + "yd") +
              "</span>");
        p1.innerText = currentAddress[0];
        p2.innerText = currentAddress[1];
        p3.innerText = currentAddress[2];

        a.innerText = "Book Now";

        if (this.filteredLocations[i]["booking_url"] != "") {
          /*        var repairUrl = this.filteredLocations[i]["booking_url"];
          var lucidRef = window.state.tsoutcome.lucidRef;
          var troubleshootedProduct = window.state.tsoutcome.troubleshootedProduct;
          troubleshootedProduct = troubleshootedProduct.replace('Samsung/','');
          repairUrl = repairUrl+'?model='+troubleshootedProduct+'&ref='+lucidRef;*/
          a.href = this.filteredLocations[i]["booking_url"];
        } else {
          a.href = "#";
        }

        a.classList.add("reservation-marker");
        a.setAttribute("data-omni-type", "microsite");
        a.setAttribute(
          "data-omni",
          "uk:repair:mobil:visit servicelocation:booking:button click:" +
            this.filteredLocations[i]["place_id"]
        );
        a.setAttribute("ga-ca", "repair");
        a.setAttribute("ga-ac", "booking");
        a.setAttribute("ga-la", storeName + " " + "book now");
        a.setAttribute("target", "_blank");
        a.setAttribute("place_id", this.filteredLocations[i]["place_id"]);
        a.setAttribute(
          "phone",
          this.filteredLocations[i]["formatted_phone_number"]
        );
        a.setAttribute("qudini", this.filteredLocations[i]["qudini"]);
        a.setAttribute("store_type", this.filteredLocations[i]["store_type"]);
        a.setAttribute(
          "store_address",
          this.filteredLocations[i]["formatted_address"]
        );
        a.setAttribute("store_name", this.filteredLocations[i]["name"]);
        a.setAttribute(
          "drop_off_service",
          this.filteredLocations[i]["drop_off_service"]
        );
        a.setAttribute("place_id", this.filteredLocations[i]["place_id"]);
        title.setAttribute(
          "lat",
          this.filteredLocations[i]["geometry"]["location"]["lat"]
        );
        title.setAttribute(
          "lng",
          this.filteredLocations[i]["geometry"]["location"]["lng"]
        );

        li.appendChild(title);
        li.appendChild(p1);
        li.appendChild(p2);
        li.appendChild(p3);

        if (currentAddress[3]) {
          var p4 = document.createElement("p");
          p4.innerText = currentAddress[3];
          li.appendChild(p4);
        }

        li.appendChild(a);

        /** Temperarily commented out next booking time **/
        //li.appendChild(nextBookingTitle);
        //li.appendChild(nextBookingParagraph);

        resultList.appendChild(li);
        //console.log('Before loader hide');
        //$(".loader-container").hide();
      }
    }

    this.initMarkerEvents();

    if (this.filteredLocations.length == 0) {
      var apology = document.createElement("li");
      var apologyText = document.createElement("h3");
      apologyText.innerText =
        "We're sorry, there are no Experience Stores within a 300km radius from you.";
      apology.appendChild(apologyText);
      apology.classList.add("sl-store-list-single-result");
      resultList.appendChild(apologyText);
    }
    if (KXpositionChanged) {
      this.map.setCenter(this.filteredLocations[1].geometry.location);
    } else {
      this.map.setCenter(this.filteredLocations[0].geometry.location);
    }
  }

  manageLoadedStores(numberOfStoresToDisplay) {
    if (this.ajaxInfoLoaded === numberOfStoresToDisplay - 1) {
      this.initMarkerEvents();
    }
  }
}
